import React from 'react';
import Header from './Header';
import Footer from './Footer';

const SecurityPolicy: React.FC = () => (
  <div className="page-container">
    <Header />
    <main className="page-content">
      <h1>Security Policy</h1>
      <p>
        Consphic takes security seriously. We implement industry-standard measures to protect your data and ensure the integrity of our services. Our team regularly reviews and updates our security practices to address emerging threats. If you have any concerns, please contact our security team.
      </p>
    </main>
    <Footer />
  </div>
);

export default SecurityPolicy;
